/* eslint-disable react/prop-types */
import React from "react";
import { Typography } from "@material-ui/core";
import useEffectAsync from "lib/react/customHooks";
import { getCompany } from "lib/services/companies";

// Companies barely change and the same ids are looked up over and over as
// MaterialTable remounts rows on each edit; cache them so we hit the API once
// per id instead of on every remount.
const companyCache = new Map();

/* This is used for the user tab
fetches the new company from the backend and returns it */
export default function UserCompanyLabel({ companyId }) {
  const [company, setCompany] = React.useState(() =>
    companyId ? companyCache.get(companyId) : undefined
  );

  useEffectAsync(
    async () => {
      // A user without a company has a null companyId; skip the lookup.
      if (!companyId) return null;
      if (companyCache.has(companyId)) return companyCache.get(companyId);
      const result = await getCompany(companyId);
      companyCache.set(companyId, result.data);
      return result.data;
    },
    setCompany,
    [companyId]
  );

  return company ? (
    <Typography display="inline" variant="body1">
      {company.name}
    </Typography>
  ) : null;
}
